<template>
  <div class="MinMax">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Ustawienia Max i Min
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          <div class="columns">
            <div class="column">
              <label class="label">Temperatura Min</label>

              <div v-for="el in datas"  v-bind:key="el.sensor" >
                  <div class="field is-horizontal">
                    <div class="field-label is-small">
                      <label class="label">{{el.name}}</label>
                    </div>
                    <div class="field">
                      <div class="control">
                        <input class="input is-small is-dark" type="text" v-model="el.valueMin" placeholder="Small input" >
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="column">
              <label class="label">Temperatura Max</label>

              <div v-for="el in datas"  v-bind:key="el.sensor">
                  <div class="field is-horizontal">
                    <div class="field-label is-small">
                      <label class="label">{{el.name}}</label>
                    </div>
                    <div class="field">
                      <div class="control">
                        <input class="input is-small  is-dark" type="text"  v-model="el.valueMax" placeholder="Small input">
                      </div>
                    </div>
                  </div>
              </div>

            </div>
            
          </div>
   
        </div>  
      </div>
      <footer class="card-footer">
        <a href="#" @click="save" class="card-footer-item">Zapisz</a>
        
        
        
      </footer>
      
    </div>
    
  </div>
</template>

<script>



export default {
  name: 'MinMax',
  props: {
    
    
  },
  data() {
    return {
      datas: [
          {sensor: 0, valueMin: 20, valueMax: 40, name: "1.CO zasilanie 1"},
          {sensor: 1, valueMin: 20, valueMax: 45, name: "2.CO zasilanie 2"},
          {sensor: 2, valueMin: 40, valueMax: 60, name: "3.CO powrót 1"},
          {sensor: 3, valueMin: 50, valueMax: 80, name: "4.CO powrót 2"},
          {sensor: 4, valueMin: 30, valueMax: 50, name: "5.CW na budynek"},
          {sensor: 5, valueMin: 30, valueMax: 50, name: "6.CW na zasobnik z kotła"},
          {sensor: 6, valueMin: 30, valueMax: 50, name: "7.CW cyrkulacja"},
          {sensor: 7, valueMin: 30, valueMax: 50, name: "8.Kol-zejście glikolu"},
          {sensor: 8, valueMin: 30, valueMax: 50, name: "9.Kol-cyrkulacja"},
          {sensor: 9, valueMin: 30, valueMax: 50, name: "10.Kol-CWZ wymiennika"},
      ],
      saving: false
    }
  },
  mounted () {
    
    this.$store.dispatch('getLimits')
    .then(response => {
      
      //console.log(response)
      this.buildForm(response[0])
    })
    .catch(error => {
        console.log(error)
        return error
    });
    
    
  },
  methods: {
    buildForm(_data){
      
      console.log(_data)

      this.datas[0].valueMin = _data.t0_min;
      this.datas[0].valueMax = _data.t0_max;

      this.datas[1].valueMin = _data.t1_min;
      this.datas[1].valueMax = _data.t1_max;

      this.datas[2].valueMin = _data.t2_min;
      this.datas[2].valueMax = _data.t2_max;

      this.datas[3].valueMin = _data.t3_min;
      this.datas[3].valueMax = _data.t3_max;

      this.datas[4].valueMin = _data.t4_min;
      this.datas[4].valueMax = _data.t4_max;

      this.datas[5].valueMin = _data.t5_min;
      this.datas[5].valueMax = _data.t5_max;

      this.datas[6].valueMin = _data.t6_min;
      this.datas[6].valueMax = _data.t6_max;

      this.datas[7].valueMin = _data.t7_min;
      this.datas[7].valueMax = _data.t7_max;

      this.datas[8].valueMin = _data.t8_min;
      this.datas[8].valueMax = _data.t8_max;

      this.datas[9].valueMin = _data.t9_min;
      this.datas[9].valueMax = _data.t9_max;
      
      console.log(this.datas)

      
    },
    
    save(){
      
      this.saving = true;
      var objData = {
        data: this.datas
      }
      this.$store.dispatch('setLimits', objData)
      .then(response => {
        
        if (response){
          this.saving = false
        }
      })
      .catch(error => {
          console.log(error)
          return error
      });


    }
  }
}
</script>

<style scoped>
  .card{
    margin-top: 10px;
  }
  .card .card-content{
    background-color: #333 !important;
  }
  .card .card-footer{
    background-color: #333 !important;
  }
  label{
    color: #ffffff !important;
  }
  input{
    background-color: #4a4a4a;
    color: #ffffff;
  }
  
</style>
